import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { ContactDetails } from './contact-details';
export { ContactDetails };
import { contactDetailsSchema } from '@schemas/business-objects/contact-details';
import { CandidateFormGroup } from './candidate-form-group';

export class ContactDetailsFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    phoneType: SchemaFormControl;
    phoneNumber: SchemaFormControl;
    otherPhoneType: SchemaFormControl;
    otherPhoneNumber: SchemaFormControl;
    email: SchemaFormControl;
    candidateId: SchemaFormControl;
    candidate: CandidateFormGroup;
  };

  declare value: Partial<ContactDetails>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(contactDetailsSchema, ContactDetails, data, options);
  }

  get object(): ContactDetails {
    return new ContactDetails(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'candidate':
        return new CandidateFormGroup();
      default:
        return undefined;
    }
  }
}

export class ContactDetailsFormArray extends PersistedFormArray {
  readonly entityName = 'ContactDetails' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(contactDetailsSchema, ContactDetails, options);
  }

  protected override createItemGroup() {
    return new ContactDetailsFormGroup();
  }

  get array(): ContactDetails[] {
    return this.controls.map((group: ContactDetailsFormGroup) => group.object);
  }
}

export class ContactDetailsPersistedArray extends PersistedArray<ContactDetails> {
  readonly entityName = 'ContactDetails' as const;

  constructor(options?: PersistedArrayOptions) {
    super(ContactDetails, options);
  }
}
